module.exports = "/images/hospital.svg?985bdd35e6e8914fa89616398f80251b";